module.exports = __webpack_public_path__ + "img/img-3.f66bb5f1.png";